import React, { useMemo } from "react";
import classNames from "classnames/bind";
import styles from "../SearchMainCategories.module.scss";
import { Image } from "../../../../components/Image/Image";
import { useHistory } from "react-router";
import { ImageType } from "@core/types";

const cx = classNames.bind(styles);

interface Category {
  id: string | number;
  name: string;
  image?: ImageType;
  parent?: string | number;
}

interface CategoryListProps {
  mainCategories: Category[];
  allCategories: Category[];
}

export const CategoryList: React.FC<CategoryListProps> = ({ mainCategories, allCategories }) => {
  const history = useHistory();

  const handleOpenCategories = (e: React.MouseEvent<HTMLDivElement>, categoryId: Category["id"]) => {
    e.stopPropagation();
    e.preventDefault();
    const hasSubcategories = allCategories?.some((x) => x.parent === categoryId);
    if (hasSubcategories) {
      history.push(`/categories/${categoryId}/subcategories`);
    } else {
      history.push(`/category-detail/${categoryId}`);
    }
  };

  const sortedMainCategories = useMemo(() => {
    const sortedMainCategories = [...(mainCategories ?? [])].sort((a, b) => {
      const aHasChildren = allCategories?.some((x) => x.parent === a.id) ?? false;
      const bHasChildren = allCategories?.some((x) => x.parent === b.id) ?? false;
      return Number(bHasChildren) - Number(aHasChildren);
    });

    return sortedMainCategories;
  }, [mainCategories, allCategories]);

  return (
    <div className={cx("masonry", "p-3 !pt-0 !pb-20")}>
      {sortedMainCategories?.map((mainCategory) => {
        const subCategories = allCategories?.filter((cat) => cat.parent === mainCategory.id);
        return (
          <div key={mainCategory.id} className={cx("masonryItem", "flex flex-col gap-2.5")}>
            <h2
              onClick={(e) => handleOpenCategories(e, mainCategory.id)}
              className="font-bold text-sm mb-2 text-[#999999] p-1.5 rounded-lg hover:bg-gray-100"
            >
              {mainCategory.name}
            </h2>
            <div className="flex flex-col gap-2.5">
              {subCategories?.map((category) => (
                <div
                  key={category.id}
                  onClick={(e) => handleOpenCategories(e, category.id)}
                  className="flex items-center bg-white rounded-lg cursor-pointer transition-colors duration-200 ease-in-out hover:bg-gray-100"
                >
                  <div className="w-12 h-12 mr-4 shrink-0">
                    <Image
                      className={cx("category-image", "w-full h-full object-cover rounded-[1rem]")}
                      src={category.image?.src}
                      downsize={false}
                      lazyLoad={false}
                    />
                  </div>
                  <span className="text-xs font-semibold  text-[#242424]">{category.name}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
